import { request } from "../../requests";
import toastr from 'toastr';
import Swal from 'sweetalert2';
export default {
  name: 'ContactForm',
  props: {
    project_id: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      form: {
        project_id: this.project_id,
        message: null
      },
      errors: {},
      loading: false
    };
  },
  methods: {
    onSubmit() {
      const toast = Swal.mixin({
        heightAuto: false
      });
      this.loading = true;
      this.errors = {};
      let data = JSON.stringify(this.form);
      return request({
        url: '/forms/contactus',
        data
      }).done(response => {
        toast.fire({
          icon: 'success',
          text: response.message,
          title: 'Success',
          position: 'center',
          showCloseButton: false,
          showCancelButton: false,
          showConfirmButton: true
        }).then(() => {
          window.location.replace('/projects/' + this.project_id + '/profile');
        });
      }).catch(this.onFail).always(() => {
        this.loading = false;
      });
    },
    onFail(response) {
      const toast = Swal.mixin({
        heightAuto: false
      });
      switch (response.status) {
        case 400:
          const responseData = response.responseJSON;
          if (responseData && responseData.errors) {
            this.errors = responseData.errors;
            toastr.error('There are form related errors. Please review and resubmit.', 'Error');
          }
          if (responseData && responseData.message) {
            toast.fire({
              icon: 'error',
              text: responseData.message,
              title: 'Error'
            });
          }
          break;
        default:
          console.debug('The server returned an error: ');
          console.error(response.responseData);
          toastr.error('Something went wrong on our servers. Please try again.', 'Error');
          break;
      }
    }
  }
};